module.exports = __webpack_public_path__ + "img/home_keyvisual.639dcf87.jpg";